export default __webpack_public_path__ + "static/media/2_home-image.65add585.jpg";